export default {
    ko: {
        close: "닫기",
        register: "등록",
        delete: "삭제",
        more: "더보기",
        monthlyViews: "한달간 조회수",
        video: "동영상",
        comments: "댓글",
        like: "좋아요",
        views: "조회수",
        times: "회",
        items: "개",
        move: "이동",
        newFolder: "새폴더",
        liveBroadcast: "생중계",
        videoMinutes: "영상회의록",
        meeting: "회의",
        date: "날짜",
        title: "제목",
        agenda: "안건",
        publicStatus: "공개여부",
        details: "상세",
        edit: "수정",
        noData: "데이터가 없습니다.",
        noVideo: "등록된 동영상이 없습니다.",
        plenarySession: "본회의",
        todayLiveSchedule: "오늘의 생중계 일정",
        noMeeting: "회의가 없습니다.",
        noCommitteeLive: "등록된 위원회 방송이 없습니다.",
        meetingDate: "회의일자",
        openingTime: "개의시각",
        meetingType: "회의구분",
        meetingName: "회의명",
        naHomepage: "국회홈페이지",
        videoUpload: "동영상 업로드",
        downloadManualConfirm: "발급 설명서를 다운 받으시겠습니까?",
        issuanceManual: "발급 설명서",
        download: "다운로드",
        scheduledLiveMeeting: "라이브 회의 예정",
        dateTime: "일시",
        selectMeeting: "회의 선택",
        changeFile: "파일변경",
        note: "비고",
        videoManagement: "동영상 관리",
        meetingCodeManagement: "회의 코드 관리",
        meetingManagement: "회의 관리",
        snsConnectionManagement: "API 키 관리",
        statistics: "통계",
        liveBroadcastManagement: "라이브 방송 관리",
        number: "대수",
        session: "회기",
        reenter: "재입력",
        upcoming: "진행예정",
        inProgress: "진행중",
        finished: "종료",
        committee: "위원회",
        location: "장소",
        recentVideos: "최근 동영상",
        top3VideosByViews: "조회수 Top3 동영상",
        top3ByPlaylistViews: "재생목록별 조회수 Top3",
        size: "크기",
        time: "시간",
        registrationDate: "등록날짜",
        snsRegistrationStatus: "SNS 등록여부",
        backToList: "목록으로",
        menu: "메뉴",
        registered: "등록 되었습니다.",
        pleaseEnterAllValues: "모든 값을 입력해주세요.",
        pleaseEnterRequiredValues: "필수 값을 입력해주세요.",
        noFileSelected: "파일이 선택되지 않았습니다.",
        all: "전체",
        selectDate: "날짜선택",
        enterTitle: "제목을 입력하세요.",
        recentMeetings: "최근회의",
        enterInformation: "정보를 입력하세요.",
        selectFile: "파일을 선택해주세요.",
        public: "전체 공개",
        partiallyPublic: "일부 공개",
        private: "비공개",
        deleteKeyConfirm: "키값을 삭제하시겠습니까?",
        enterMeetingInfo: "회의정보를 입력하세요.",
        videoRegistration: "동영상 등록",
        sunday: "일요일",
        monday: "월요일",
        tuesday: "화요일",
        wednesday: "수요일",
        thursday: "목요일",
        friday: "금요일",
        saturday: "토요일",
        fillInBlank: "빈칸을 입력해주세요.",
        pleaseEnter: "입력하세요.",
        googleLogin: "구글로그인",
        committeeMeeting: "위원회회의",
        plenary: "본",
        committeeShort: "위",
        transmission: "전송",
        rename: "이름변경",
        videoRegister: "동영상등록",
        meetingRoom: "회의실",
        type: "유형",
        none: "없음",
        folderName: "폴더명",
        selectFolderToMove: "이동할폴더를 선택하세요",
        renameAction: "이름바꾸기",
        newName: "바꿀이름",
        enterInfoToTransmit: "전송할 정보를 입력하세요.",
        protocol: "프로토콜",
        ipToConnect: "연결하려는Ip",
        path: "경로",
        password: "비밀번호",
        pleaseEnterPassword: "비밀번호를 입력해주세요.",
        deleteConfirm: "삭제하시겠습니까?",
        abnormalAccess: "비정상적인 접근",
        folderCannotBeTransmitted: "폴더는 전송할 수 없습니다.",
        transmissionComplete: "전송을 완료했습니다.",
        transmissionFailed: "전송에 실패했습니다.",
        checkFileExtension: "확장자를 확인하세요.",
        userManagement: "사용자관리",
        // 추가된 키들
        select: "선택하세요",
        period: "기간",
        filterType: "타입",
        userCreated: "사용자가 생성되었습니다",
        userCreationFailed: "사용자 생성에 실패했습니다",
        noUserSelected: "선택된 사용자가 없습니다",
        deleteFailed: "삭제에 실패했습니다",
        userName: "사용자명",
        name: "이름",
        email: "이메일",
        phoneNumber: "전화번호",
        pleaseEnterRequiredFields: "필수 항목을 입력해주세요",
        notSelected: "선택안함",
        file: "파일",
        description: "설명",
        save: "저장",
        videoEdit: "동영상 수정",
        pleaseCheckInputFields: "입력 항목을 확인해주세요",
        userRegistration: "사용자 등록",
        userId: "사용자ID",
        confirmPassword: "비밀번호 확인",
        pleaseSelectGroupCode: "그룹코드를 선택해주세요",
        codeRegistration: "코드 등록",
        codeId: "코드 아이디",
        codeName: "코드명",
        order: "순서",
        memo: "메모",
        pleaseSelectStartDate: "시작일을 선택해주세요",
        pleaseSelectEndDate: "종료일을 선택해주세요",
        sessionRegistration: "회기 등록",
        startDate: "시작일",
        endDate: "종료일",
        sessionName: "회기명",
        sortOrder: "정렬순서",
        saved: "저장되었습니다",
        auth: "인증",
        pleaseSelectSession: "회기를 선택해주세요",
        pleaseSelectScheduledMeetingDate: "회의 예정일을 선택해주세요",
        pleaseSelectMeetingType: "회의 유형을 선택해주세요",
        meetingRegistration: "회의 등록",
        meetingRound: "회차",
        scheduledMeetingDate: "회의 예정일",
        // 추가 하드코딩 키들
        connectFile: "파일연결하기",
        viewRelatedVideos: "관련영상보기",
        search: "조회",
        parentCode: "상위코드",
        childCode: "하위코드",
        id: "아이디",
        requestUrl: "요청주소",
        requestType: "요청타입",
        message: "메세지",
        accessDate: "접속일자",
        daily: "일일",
        weekly: "주간",
        monthly: "월간",
        count: "건",
        sessionId: "회기 ID",
        createdDate: "등록일",
        createdBy: "등록자",
        transferMethod: "전송 방식",
        searchFolder: "폴더 검색",
        selectTimezone: "타임존 선택",
        selectStartDate: "시작일 선택",
        selectEndDate: "종료일 선택",
        scheduledDate: "예정일",
        koreaSeoul: "한국 (서울)",
        kyrgyzstanBishkek: "키르기스스탄 (비슈케크)",
        uzbekistanTashkent: "우즈베키스탄 (타슈켄트)",
        kazakhstanAlmaty: "카자흐스탄 (알마티)",
        turkmenistanAshgabat: "투르크메니스탄 (아슈하바트)",
        tajikistanDushanbe: "타지키스탄 (두샨베)",
        japanTokyo: "일본 (도쿄)",
        chinaBeijing: "중국 (베이징)",
        singapore: "싱가포르",
        indiaDelhi: "인도 (델리)",
        ukLondon: "영국 (런던)",
        // 상세 모달 키들
        videoTitle: "동영상 제목",
        fileName: "파일명",
        fileSize: "파일 크기",
        playTime: "재생 시간",
        modifiedDate: "수정일",
        modifiedBy: "수정자",
        meetingPlace: "회의 장소",
        liveId: "라이브 ID",
        meetingTitle: "회의 제목",
        videoFile: "동영상 파일",
        videoPath: "비디오 경로",
        meetingDescription: "회의 설명",
        useYn: "사용여부",
        use: "사용",
        notUse: "미사용",
        videoDetail: "동영상 상세",
        snsType: "SNS 유형",
        snsVideoId: "SNS 영상 ID",
        meetingDetail: "회의 상세",
        relatedVideos: "관련 동영상",
        videoConnect: "동영상 연결",
        videoConnectSubtitle: "연결시 동영상 관리에서 관리할 수 있습니다.",
        clickEditToModify: "수정하려면 수정버튼을 클릭하세요",
        clickSaveToSave: "저장하려면 저장버튼을 클릭하세요.",
        requiredMeetingTitle: "회의 제목 *",
        requiredVideoFile: "동영상 파일 *",
        requiredVideoPath: "비디오 경로 *",
        // 로그인 관련
        loginFailed: "아이디와 비밀번호가 맞지 않습니다.",
        pleaseEnterIdPassword: "아이디 및 비밀번호 입력란이 비어있습니다.",
        // 메뉴 관련
        logManagement: "로그관리",
        basicCodeManagement: "공통코드 관리",
        statisticsManagement: "통계 관리",
        // 통계 관련
        statisticsLoadFailed: "통계 데이터를 불러오는 데 실패했습니다.",
        confirmGenerateStatistics: "통계를 생성하시겠습니까?",
        statisticsGeneratedSuccess: "통계가 성공적으로 생성되었습니다.",
        statisticsGenerateFailed: "통계 생성에 실패했습니다.",
        dailyStatisticsTrend: "일일 통계 추이 (최근 30일)",
        weeklyStatisticsTrend: "주간 통계 추이 (최근 30주)",
        monthlyStatisticsTrend: "월간 통계 추이 (최근 30개월)",
        totalStatisticsTrend: "전체 통계 추이 (일일 기준 최근 30일)",
        statisticsTrend: "통계 추이",
        total: "전체",
        videoUploadLabel: "영상 업로드",
        snsUpload: "SNS 업로드",
        selectMondayHint: "주의 시작일(월요일) 선택",
        generateStatistics: "통계 생성",
        loading: "로딩 중...",
        statisticsTrendRecent30: "통계 추이 (최근 30일)",
        // 퀵메뉴 관련
        quickMenu: "QuickMenu",
        top: "Top",
        // 시스템 관련
        internetBroadcastSystem: "인터넷 방송 시스템",
        // 코드 관리 관련
        idInUse: "사용중인 아이디입니다.",
        // 로그인 관련 추가
        enterYourId: "아이디를 입력하세요",
        enterYourPassword: "비밀번호를 입력하세요",
        login: "로그인",
        logout: "로그아웃",
        // 회의 관련 추가
        step: "단계",
        age: "대수",
        ipAddress: "IP 주소",
        departmentId: "부서ID",
        // 추가 메시지
        pleaseSelectFile: "파일을 선택해주세요.",
        canDownloadOnlyOneFile: "파일은 하나만 다운로드 할 수 있습니다.",
        pleaseSelectChildCode: "하위코드를 선택해주세요.",
        alreadyNotUsed: "이미 미사용 처리된 코드입니다.",
        errorOccurred: "오류가 발생했습니다.",
        // SNS 영상 삭제 관련
        deleteVideoConfirmMessage: "선택한 영상을 삭제하시겠습니까?",
        deleteSnsVideoTogether: "SNS에 업로드된 영상도 함께 삭제",
        deleteWithSnsSuccess: "SNS 영상과 함께 삭제되었습니다.",
        deleteSuccess: "삭제되었습니다.",
        updateSuccess: "수정되었습니다.",
        cancel: "취소",
        // 사용자 상세/수정 관련
        userDetail: "사용자 상세",
        userEdit: "사용자 수정",
        newPassword: "새 비밀번호",
        passwordChangeHint: "비밀번호를 변경하려면 아래에 입력하세요. 비워두면 기존 비밀번호가 유지됩니다.",
        requiredField: "필수 입력 항목입니다",
        invalidEmail: "올바른 이메일 형식이 아닙니다",
        passwordMismatch: "비밀번호가 일치하지 않습니다",
        basicInfo: "기본 정보",
        accountInfo: "계정 정보",
        historyInfo: "이력 정보",
        status: "상태",
        active: "활성",
        inactive: "비활성",
        role: "권한",
        admin: "관리자",
        editor: "편집자",
        user: "일반 사용자",
        timezone: "타임존",
        enterMeetingName: "회의명을 입력하세요",
        // 전송 현황 관련
        transferStatus: "전송 상태",
        transferHistory: "전송 이력",
        transferDateTime: "전송 일시",
        transferTarget: "전송 대상",
        failureReason: "실패 사유",
        retry: "재전송",
        noTransferHistory: "전송 이력이 없습니다",
        notTransferred: "미전송",
        transferSuccess: "전송 성공",
        transferFailed: "전송 실패",
        transferInfo: "전송 정보",
        ftpTransfer: "FTP 전송",
        // 요일 약자
        mon: "월",
        tue: "화",
        wed: "수",
        thu: "목",
        fri: "금",
        sat: "토",
        sun: "일",
        day: "일",
        totalStatisticsRatio: "전체 통계 비율",
        // 동영상 연결 모달
        videoFolderPath: "비디오 폴더 경로 *",
        videoFileName: "비디오 파일명 *",
        fullPath: "전체 경로",
        pleaseEnterVideoPath: "비디오 경로를 입력해주세요.",
        pleaseEnterVideoFileName: "비디오 파일명을 입력해주세요.",
        videoConnectFailed: "동영상 연결에 실패했습니다.",
        // 메뉴/모달
        folderCreate: "폴더 생성",
        editModeGuide: "수정하려면 하단의 수정 버튼을 클릭하세요.",
        noLiveScheduleToday: "오늘 예정된 생중계 일정이 없습니다.",
        // 유효성 검사
        pleaseSelectMeeting: "회의를 선택해주세요.",
        pleaseSelectPublicStatus: "공개 상태를 선택해주세요.",
        pleaseSelectDate: "날짜를 선택해주세요.",
        // API 키/YouTube 인증
        youtubeAuthSuccess: "YouTube 인증이 완료되었습니다.",
        youtubeAuthFailed: "YouTube 인증에 실패했습니다.",
        popupBlocked: "팝업이 차단되었습니다. 팝업 차단을 해제해주세요.",
        fileUploadFailed: "파일 업로드에 실패했습니다.",
        fileUploading: "파일 업로드 중...",
        uploading: "업로드 중...",
        // 타임존
        franceParis: "프랑스 (파리)",
        germanyBerlin: "독일 (베를린)",
        russiaMoscow: "러시아 (모스크바)",
        usNewYork: "미국 (뉴욕)",
        usLosAngeles: "미국 (로스앤젤레스)",
        usChicago: "미국 (시카고)",
        australiaSydney: "호주 (시드니)",
        newZealandAuckland: "뉴질랜드 (오클랜드)",
        // 삭제 모달
        snsUploadedVideoCount: "{count}개의 영상이 SNS에 업로드되어 있습니다.",
        countUnit: "개",
    },
    en: {
        close: "Close",
        register: "Register",
        delete: "Delete",
        more: "More",
        monthlyViews: "Monthly Views",
        video: "Video",
        comments: "Comments",
        like: "Like",
        views: "Views",
        times: "Times",
        items: "Items",
        move: "Move",
        newFolder: "New Folder",
        liveBroadcast: "Live Broadcast",
        videoMinutes: "Video Minutes",
        meeting: "Meeting",
        date: "Date",
        title: "Title",
        agenda: "Agenda",
        publicStatus: "Public Status",
        details: "Details",
        edit: "Edit",
        noData: "No Data Available",
        noVideo: "No videos registered.",
        plenarySession: "Plenary Session",
        todayLiveSchedule: "Today's Live Schedule",
        noMeeting: "No Meeting",
        noCommitteeLive: "No committee broadcasts available.",
        meetingDate: "Meeting Date",
        openingTime: "Opening Time",
        meetingType: "Meeting Type",
        meetingName: "Meeting Name",
        naHomepage: "National Assembly Homepage",
        videoUpload: "Video Upload",
        downloadManualConfirm: "Do you want to download the issuance manual?",
        issuanceManual: "Issuance Manual",
        download: "Download",
        scheduledLiveMeeting: "Scheduled Live Meeting",
        dateTime: "Date and Time",
        selectMeeting: "Select Meeting",
        changeFile: "Change File",
        note: "Note",
        videoManagement: "Video Management",
        meetingCodeManagement: "Meeting Code Management",
        meetingManagement: "Meeting Management",
        snsConnectionManagement: "API Key Management",
        statistics: "Statistics",
        liveBroadcastManagement: "Live Broadcast Management",
        number: "Number",
        session: "Session",
        reenter: "Re-enter",
        upcoming: "Upcoming",
        inProgress: "In Progress",
        finished: "Finished",
        committee: "Committee",
        location: "Location",
        recentVideos: "Recent Videos",
        top3VideosByViews: "Top 3 Videos by Views",
        top3ByPlaylistViews: "Top 3 by Playlist Views",
        size: "Size",
        time: "Time",
        registrationDate: "Registration Date",
        snsRegistrationStatus: "SNS Registration Status",
        backToList: "Back to List",
        menu: "Menu",
        registered: "Registered",
        pleaseEnterAllValues: "Please enter all values.",
        pleaseEnterRequiredValues: "Please enter the required values.",
        noFileSelected: "No file selected.",
        all: "All",
        selectDate: "Select Date",
        enterTitle: "Enter the Title",
        recentMeetings: "Recent Meetings",
        enterInformation: "Enter Information",
        selectFile: "Select File",
        public: "Public",
        partiallyPublic: "Partially Public",
        private: "Private",
        deleteKeyConfirm: "Do you want to delete the key?",
        enterMeetingInfo: "Enter Meeting Information",
        videoRegistration: "Register Video",
        sunday: "Sunday",
        monday: "Monday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
        thursday: "Thursday",
        friday: "Friday",
        saturday: "Saturday",
        fillInBlank: "Please fill in the blank.",
        pleaseEnter: "Please enter.",
        googleLogin: "Google Login",
        committeeMeeting: "Committee Meeting",
        plenary: "P",
        committeeShort: "C",
        transmission: "Transmission",
        rename: "Rename",
        videoRegister: "Video Registration",
        meetingRoom: "Meeting Room",
        type: "Type",
        none: "None",
        folderName: "Folder Name",
        selectFolderToMove: "Please select the folder to move.",
        renameAction: "Rename",
        newName: "New Name",
        enterInfoToTransmit: "Please enter the information to transmit.",
        protocol: "Protocol",
        ipToConnect: "IP to connect",
        path: "Path",
        password: "Password",
        pleaseEnterPassword: "Please enter your password.",
        deleteConfirm: "Are you sure you want to delete this?",
        abnormalAccess: "Abnormal Access",
        folderCannotBeTransmitted: "Folders cannot be transmitted.",
        transmissionComplete: "The transmission is complete.",
        transmissionFailed: "The transmission has failed.",
        checkFileExtension: "Please check the file extension.",
        userManagement: "User Management",
        // Additional keys
        select: "Select",
        period: "Period",
        filterType: "Type",
        userCreated: "User has been created",
        userCreationFailed: "User creation failed",
        noUserSelected: "No user selected",
        deleteFailed: "Delete failed",
        userName: "User Name",
        name: "Name",
        email: "Email",
        phoneNumber: "Phone Number",
        pleaseEnterRequiredFields: "Please enter required fields",
        notSelected: "Not Selected",
        file: "File",
        description: "Description",
        save: "Save",
        videoEdit: "Video Edit",
        pleaseCheckInputFields: "Please check input fields",
        userRegistration: "User Registration",
        userId: "User ID",
        confirmPassword: "Confirm Password",
        pleaseSelectGroupCode: "Please select group code",
        codeRegistration: "Code Registration",
        codeId: "Code ID",
        codeName: "Code Name",
        order: "Order",
        memo: "Memo",
        pleaseSelectStartDate: "Please select start date",
        pleaseSelectEndDate: "Please select end date",
        sessionRegistration: "Session Registration",
        startDate: "Start Date",
        endDate: "End Date",
        sessionName: "Session Name",
        sortOrder: "Sort Order",
        saved: "Saved",
        auth: "Authentication",
        pleaseSelectSession: "Please select session",
        pleaseSelectScheduledMeetingDate: "Please select scheduled meeting date",
        pleaseSelectMeetingType: "Please select meeting type",
        meetingRegistration: "Meeting Registration",
        meetingRound: "Meeting Round",
        scheduledMeetingDate: "Scheduled Meeting Date",
        // Additional hardcoded keys
        connectFile: "Connect File",
        viewRelatedVideos: "View Related Videos",
        search: "Search",
        parentCode: "Parent Code",
        childCode: "Child Code",
        id: "ID",
        requestUrl: "Request URL",
        requestType: "Request Type",
        message: "Message",
        accessDate: "Access Date",
        daily: "Daily",
        weekly: "Weekly",
        monthly: "Monthly",
        count: "Count",
        sessionId: "Session ID",
        createdDate: "Created Date",
        createdBy: "Created By",
        transferMethod: "Transfer Method",
        searchFolder: "Search Folder",
        selectTimezone: "Select Timezone",
        selectStartDate: "Select Start Date",
        selectEndDate: "Select End Date",
        scheduledDate: "Scheduled Date",
        koreaSeoul: "Korea (Seoul)",
        kyrgyzstanBishkek: "Kyrgyzstan (Bishkek)",
        uzbekistanTashkent: "Uzbekistan (Tashkent)",
        kazakhstanAlmaty: "Kazakhstan (Almaty)",
        turkmenistanAshgabat: "Turkmenistan (Ashgabat)",
        tajikistanDushanbe: "Tajikistan (Dushanbe)",
        japanTokyo: "Japan (Tokyo)",
        chinaBeijing: "China (Beijing)",
        singapore: "Singapore",
        indiaDelhi: "India (Delhi)",
        ukLondon: "UK (London)",
        // Detail modal keys
        videoTitle: "Video Title",
        fileName: "File Name",
        fileSize: "File Size",
        playTime: "Play Time",
        modifiedDate: "Modified Date",
        modifiedBy: "Modified By",
        meetingPlace: "Meeting Place",
        liveId: "Live ID",
        meetingTitle: "Meeting Title",
        videoFile: "Video File",
        videoPath: "Video Path",
        meetingDescription: "Meeting Description",
        useYn: "Use Status",
        use: "Use",
        notUse: "Not Use",
        videoDetail: "Video Details",
        snsType: "SNS Type",
        snsVideoId: "SNS Video ID",
        meetingDetail: "Meeting Details",
        relatedVideos: "Related Videos",
        videoConnect: "Connect Video",
        videoConnectSubtitle: "After connecting, you can manage it in video management.",
        clickEditToModify: "Click Edit to modify",
        clickSaveToSave: "Click Save to save.",
        requiredMeetingTitle: "Meeting Title *",
        requiredVideoFile: "Video File *",
        requiredVideoPath: "Video Path *",
        // Login related
        loginFailed: "ID or password is incorrect.",
        pleaseEnterIdPassword: "Please enter your ID and password.",
        // Menu related
        logManagement: "Log Management",
        basicCodeManagement: "Common Code Management",
        statisticsManagement: "Statistics Management",
        // Statistics related
        statisticsLoadFailed: "Failed to load statistics data.",
        confirmGenerateStatistics: "Do you want to generate statistics?",
        statisticsGeneratedSuccess: "Statistics generated successfully.",
        statisticsGenerateFailed: "Failed to generate statistics.",
        dailyStatisticsTrend: "Daily Statistics Trend (Last 30 days)",
        weeklyStatisticsTrend: "Weekly Statistics Trend (Last 30 weeks)",
        monthlyStatisticsTrend: "Monthly Statistics Trend (Last 30 months)",
        totalStatisticsTrend: "Total Statistics Trend (Daily basis, Last 30 days)",
        statisticsTrend: "Statistics Trend",
        total: "Total",
        videoUploadLabel: "Video Upload",
        snsUpload: "SNS Upload",
        selectMondayHint: "Select week start date (Monday)",
        generateStatistics: "Generate Statistics",
        loading: "Loading...",
        statisticsTrendRecent30: "Statistics Trend (Last 30 days)",
        // Quick menu related
        quickMenu: "QuickMenu",
        top: "Top",
        // System related
        internetBroadcastSystem: "Internet Broadcast System",
        // Code management related
        idInUse: "This ID is already in use.",
        // Login related additions
        enterYourId: "Enter your ID",
        enterYourPassword: "Enter your password",
        login: "Login",
        logout: "Logout",
        // Meeting related additions
        step: "Step",
        age: "Age",
        ipAddress: "IP Address",
        departmentId: "Department ID",
        // Additional messages
        pleaseSelectFile: "Please select a file.",
        canDownloadOnlyOneFile: "You can download only one file.",
        pleaseSelectChildCode: "Please select a child code.",
        alreadyNotUsed: "This code is already marked as not used.",
        errorOccurred: "An error occurred.",
        // SNS video deletion related
        deleteVideoConfirmMessage: "Are you sure you want to delete the selected video(s)?",
        deleteSnsVideoTogether: "Also delete videos uploaded to SNS",
        deleteWithSnsSuccess: "Deleted along with SNS videos.",
        deleteSuccess: "Deleted successfully.",
        updateSuccess: "Updated successfully.",
        cancel: "Cancel",
        // User detail/edit related
        userDetail: "User Details",
        userEdit: "Edit User",
        newPassword: "New Password",
        passwordChangeHint: "Enter below to change password. Leave blank to keep current password.",
        requiredField: "This field is required",
        invalidEmail: "Invalid email format",
        passwordMismatch: "Passwords do not match",
        basicInfo: "Basic Information",
        accountInfo: "Account Information",
        historyInfo: "History Information",
        status: "Status",
        active: "Active",
        inactive: "Inactive",
        role: "Role",
        admin: "Administrator",
        editor: "Editor",
        user: "User",
        timezone: "Timezone",
        enterMeetingName: "Enter meeting name",
        // Transfer status related
        transferStatus: "Transfer Status",
        transferHistory: "Transfer History",
        transferDateTime: "Transfer Date",
        transferTarget: "Target",
        failureReason: "Failure Reason",
        retry: "Retry",
        noTransferHistory: "No transfer history",
        notTransferred: "Not Transferred",
        transferSuccess: "Transfer Success",
        transferFailed: "Transfer Failed",
        transferInfo: "Transfer Info",
        ftpTransfer: "FTP Transfer",
        // Day abbreviations
        mon: "Mon",
        tue: "Tue",
        wed: "Wed",
        thu: "Thu",
        fri: "Fri",
        sat: "Sat",
        sun: "Sun",
        day: "",
        totalStatisticsRatio: "Total Statistics Ratio",
        videoFolderPath: "Video Folder Path *",
        videoFileName: "Video File Name *",
        fullPath: "Full Path",
        pleaseEnterVideoPath: "Please enter the video path.",
        pleaseEnterVideoFileName: "Please enter the video file name.",
        videoConnectFailed: "Failed to connect video.",
        folderCreate: "Create Folder",
        editModeGuide: "Click the Edit button below to modify.",
        noLiveScheduleToday: "No live broadcast scheduled for today.",
        pleaseSelectMeeting: "Please select a meeting.",
        pleaseSelectPublicStatus: "Please select public status.",
        pleaseSelectDate: "Please select a date.",
        youtubeAuthSuccess: "YouTube authentication completed.",
        youtubeAuthFailed: "YouTube authentication failed.",
        popupBlocked: "Popup is blocked. Please allow popups.",
        fileUploadFailed: "File upload failed.",
        fileUploading: "Uploading file...",
        uploading: "Uploading...",
        franceParis: "France (Paris)",
        germanyBerlin: "Germany (Berlin)",
        russiaMoscow: "Russia (Moscow)",
        usNewYork: "USA (New York)",
        usLosAngeles: "USA (Los Angeles)",
        usChicago: "USA (Chicago)",
        australiaSydney: "Australia (Sydney)",
        newZealandAuckland: "New Zealand (Auckland)",
        // Delete modal
        snsUploadedVideoCount: "{count} video(s) are uploaded to SNS.",
        countUnit: "",
    },
    kg: {
        close: "Жабуу",
        register: "Каттоо",
        delete: "Өчүрүү",
        more: "Көбүрөөк",
        monthlyViews: "Бир айдагы көрүүлөр",
        video: "Видео",
        comments: "Комментарийлер",
        like: "Жактыруу",
        views: "Көрүүлөр",
        times: "Жолу",
        items: "Тетиктер",
        move: "Көчүрүү",
        newFolder: "Жаңы папка",
        liveBroadcast: "Түз эфир",
        videoMinutes: "Видео протокол",
        meeting: "Жыйын",
        date: "Дата",
        title: "Тема",
        agenda: "Күн тартиби",
        publicStatus: "Ачык статусу",
        details: "Толугу менен",
        edit: "Оңдоо",
        noData: "Маалымат жок",
        noVideo: "Катталган видео жок.",
        plenarySession: "Жалпы жыйын",
        todayLiveSchedule: "Бүгүнкү түз эфирдин расписаниеси",
        noMeeting: "Жыйын жок",
        noCommitteeLive: "Катталган комитет берүүлөрү жок.",
        meetingDate: "Жыйындын күнү",
        openingTime: "Башталган убактысы",
        meetingType: "Жыйындын түрү",
        meetingName: "Жыйындын аталышы",
        naHomepage: "Улуттук Ассамблеянын башкы бет",
        videoUpload: "Видео жүктөө",
        downloadManualConfirm: "Нускаманы жүктөп аласызбы?",
        issuanceManual: "Нускама",
        download: "Жүктөп алуу",
        scheduledLiveMeeting: "Жайгаштырылган түз эфир",
        dateTime: "Дата жана убакыт",
        selectMeeting: "Жыйын тандаңыз",
        changeFile: "Файлды өзгөртүү",
        note: "Эскертүү",
        videoManagement: "Видеону башкаруу",
        meetingCodeManagement: "Жыйындын кодун башкаруу",
        meetingManagement: "Жыйын башкаруу",
        snsConnectionManagement: "API ачкыч башкаруу",
        statistics: "Статистика",
        liveBroadcastManagement: "Түз эфирди башкаруу",
        number: "Саны",
        session: "Сессия",
        reenter: "Кайра киргизүү",
        upcoming: "Жакында",
        inProgress: "Жүрүп жатат",
        finished: "Бүттү",
        committee: "Комитет",
        location: "Жайгашкан жери",
        recentVideos: "Акыркы видеолор",
        top3VideosByViews: "Көрүүлөрү көп 3 видео",
        top3ByPlaylistViews: "Плейлисттер боюнча 3 көп көрүлгөн видео",
        size: "Көлөм",
        time: "Убакыт",
        registrationDate: "Каттоо күнү",
        snsRegistrationStatus: "SNS каттоо статусу",
        backToList: "Тизмеге кайтуу",
        menu: "Меню",
        registered: "Катталды",
        pleaseEnterAllValues: "Бардык маанилерди киргизиңиз.",
        pleaseEnterRequiredValues: "Керектүү маанилерди киргизиңиз.",
        noFileSelected: "Файл тандаган жоксуз.",
        all: "Баары",
        selectDate: "Күн тандаңыз",
        enterTitle: "Тема киргизиңиз",
        recentMeetings: "Акыркы жыйындар",
        enterInformation: "Маалымат киргизиңиз",
        selectFile: "Файл тандаңыз",
        public: "Ачык",
        partiallyPublic: "Жарым жартылай ачык",
        private: "Жеке",
        deleteKeyConfirm: "Ключту өчүрөсүзбү?",
        enterMeetingInfo: "Жыйындын маалыматын киргизиңиз",
        videoRegistration: "Видеону каттоо",
        sunday: "Жекшемби",
        monday: "Дүйшөмбү",
        tuesday: "Шейшемби",
        wednesday: "Шаршемби",
        thursday: "Бейшемби",
        friday: "Жума",
        saturday: "Ишемби",
        fillInBlank: "Бошту толтуруңуз.",
        pleaseEnter: "Киргизиңиз.",
        googleLogin: "Google Кирүү",
        committeeMeeting: "комитетинин заседаниеси",
        plenary: "П",
        committeeShort: "К",
        transmission: "Жөнөтүү",
        rename: "Атын өзгөртүү",
        videoRegister: "Видеону каттоо",
        meetingRoom: "Жыйындар залы",
        type: "Түрү",
        none: "Жок",
        folderName: "Папканын аталышы",
        selectFolderToMove: "Көчүрүлө турган папканы тандаңыз.",
        renameAction: "Атын өзгөртүү",
        newName: "Жаңы аталыш",
        enterInfoToTransmit: "Жөнөтүлө турган маалыматты киргизиңиз.",
        protocol: "Протокол",
        ipToConnect: "Байланыш түзө турган IP",
        path: "Жол",
        password: "Сырсөз",
        pleaseEnterPassword: "Сырсөзүңүздү киргизиңиз.",
        deleteConfirm: "Чынында эле өчүрүүнү каалайсызбы?",
        abnormalAccess: "Кадимки эмес кирүү",
        folderCannotBeTransmitted: "Папкаларды жөнөтүү мүмкүн эмес.",
        transmissionComplete: "Жөнөтүү бүткөрүлдү.",
        transmissionFailed: "Жөнөтүү ийгиликсиз болду.",
        checkFileExtension: "Файлдын кеңейтүүсүн текшериңиз.",
        userManagement: "Колдонуучуларды башкаруу",
        // Кошумча ачкычтар
        select: "Тандаңыз",
        period: "Мезгил",
        filterType: "Түрү",
        userCreated: "Колдонуучу түзүлдү",
        userCreationFailed: "Колдонуучуну түзүү ишке ашкан жок",
        noUserSelected: "Колдонуучу тандалган жок",
        deleteFailed: "Өчүрүү ишке ашкан жок",
        userName: "Колдонуучу аты",
        name: "Аты",
        email: "Электрондук почта",
        phoneNumber: "Телефон номери",
        pleaseEnterRequiredFields: "Милдеттүү талааларды толтуруңуз",
        notSelected: "Тандалган жок",
        file: "Файл",
        description: "Сүрөттөмө",
        save: "Сактоо",
        videoEdit: "Видеону оңдоо",
        pleaseCheckInputFields: "Киргизүү талааларын текшериңиз",
        userRegistration: "Колдонуучуну каттоо",
        userId: "Колдонуучу ID",
        confirmPassword: "Сырсөздү ырастоо",
        pleaseSelectGroupCode: "Топ кодун тандаңыз",
        codeRegistration: "Код каттоо",
        codeId: "Код ID",
        codeName: "Код аты",
        order: "Тартип",
        memo: "Эскертме",
        pleaseSelectStartDate: "Башталган күндү тандаңыз",
        pleaseSelectEndDate: "Аяктаган күндү тандаңыз",
        sessionRegistration: "Сессия каттоо",
        startDate: "Башталган күн",
        endDate: "Аяктаган күн",
        sessionName: "Сессия аты",
        sortOrder: "Сорттоо тартиби",
        saved: "Сакталды",
        auth: "Аутентификация",
        pleaseSelectSession: "Сессияны тандаңыз",
        pleaseSelectScheduledMeetingDate: "Жыйын күнүн тандаңыз",
        pleaseSelectMeetingType: "Жыйын түрүн тандаңыз",
        meetingRegistration: "Жыйын каттоо",
        meetingRound: "Жыйын туру",
        scheduledMeetingDate: "Пландалган жыйын күнү",
        // Кошумча ачкычтар
        connectFile: "Файлды туташтыруу",
        viewRelatedVideos: "Байланышкан видеолорду көрүү",
        search: "Издөө",
        parentCode: "Башкы код",
        childCode: "Кошумча код",
        id: "ID",
        requestUrl: "Суроо-талап URL",
        requestType: "Суроо-талап түрү",
        message: "Билдирүү",
        accessDate: "Кирүү күнү",
        daily: "Күнүмдүк",
        weekly: "Жумалык",
        monthly: "Айлык",
        count: "Саны",
        sessionId: "Сессия ID",
        createdDate: "Түзүлгөн күн",
        createdBy: "Түзүүчү",
        transferMethod: "Өткөрүп берүү ыкмасы",
        searchFolder: "Папканы издөө",
        selectTimezone: "Убакыт алкагын тандоо",
        selectStartDate: "Башталган күндү тандоо",
        selectEndDate: "Аяктаган күндү тандоо",
        scheduledDate: "Пландалган күн",
        koreaSeoul: "Корея (Сеул)",
        kyrgyzstanBishkek: "Кыргызстан (Бишкек)",
        uzbekistanTashkent: "Өзбекстан (Ташкент)",
        kazakhstanAlmaty: "Казакстан (Алматы)",
        turkmenistanAshgabat: "Түркмөнстан (Ашхабад)",
        tajikistanDushanbe: "Тажикстан (Душанбе)",
        japanTokyo: "Жапония (Токио)",
        chinaBeijing: "Кытай (Бээжин)",
        singapore: "Сингапур",
        indiaDelhi: "Индия (Дели)",
        ukLondon: "Улуу Британия (Лондон)",
        // Толук модал ачкычтары
        videoTitle: "Видео аталышы",
        fileName: "Файл аты",
        fileSize: "Файл көлөмү",
        playTime: "Ойнотуу убактысы",
        modifiedDate: "Өзгөртүлгөн күн",
        modifiedBy: "Өзгөртүүчү",
        meetingPlace: "Жыйын орду",
        liveId: "Түз эфир ID",
        meetingTitle: "Жыйын аталышы",
        videoFile: "Видео файл",
        videoPath: "Видео жолу",
        meetingDescription: "Жыйын сүрөттөмөсү",
        useYn: "Колдонуу абалы",
        use: "Колдонуу",
        notUse: "Колдонбоо",
        videoDetail: "Видео тууралуу маалымат",
        snsType: "SNS түрү",
        snsVideoId: "SNS видео ID",
        meetingDetail: "Жыйын тууралуу маалымат",
        relatedVideos: "Байланышкан видеолор",
        videoConnect: "Видеону туташтыруу",
        videoConnectSubtitle: "Туташтыргандан кийин, видео башкарууда башкара аласыз.",
        clickEditToModify: "Өзгөртүү үчүн Оңдоо баскычын басыңыз",
        clickSaveToSave: "Сактоо үчүн Сактоо баскычын басыңыз.",
        requiredMeetingTitle: "Жыйын аталышы *",
        requiredVideoFile: "Видео файл *",
        requiredVideoPath: "Видео жолу *",
        // Кирүү байланышкан
        loginFailed: "ID же сырсөз туура эмес.",
        pleaseEnterIdPassword: "ID жана сырсөзүңүздү киргизиңиз.",
        // Меню байланышкан
        logManagement: "Журнал башкаруу",
        basicCodeManagement: "Жалпы код башкаруу",
        statisticsManagement: "Статистика башкаруу",
        // Статистика байланышкан
        statisticsLoadFailed: "Статистика маалыматын жүктөө ишке ашкан жок.",
        confirmGenerateStatistics: "Статистиканы түзөсүзбү?",
        statisticsGeneratedSuccess: "Статистика ийгиликтүү түзүлдү.",
        statisticsGenerateFailed: "Статистиканы түзүү ишке ашкан жок.",
        dailyStatisticsTrend: "Күндөлүк статистика тенденциясы (акыркы 30 күн)",
        weeklyStatisticsTrend: "Жумалык статистика тенденциясы (акыркы 30 жума)",
        monthlyStatisticsTrend: "Айлык статистика тенденциясы (акыркы 30 ай)",
        totalStatisticsTrend: "Жалпы статистика тенденциясы (күндөлүк негизде, акыркы 30 күн)",
        statisticsTrend: "Статистика тенденциясы",
        total: "Бардыгы",
        videoUploadLabel: "Видео жүктөө",
        snsUpload: "SNS жүктөө",
        selectMondayHint: "Жуманын башталган күнүн тандаңыз (Дүйшөмбү)",
        generateStatistics: "Статистиканы түзүү",
        loading: "Жүктөлүүдө...",
        statisticsTrendRecent30: "Статистика тенденциясы (акыркы 30 күн)",
        // Тез меню байланышкан
        quickMenu: "Тез меню",
        top: "Үстүнө",
        // Система байланышкан
        internetBroadcastSystem: "Интернет берүү системасы",
        // Код башкаруу байланышкан
        idInUse: "Бул ID колдонулууда.",
        // Кирүү байланышкан кошумча
        enterYourId: "ID киргизиңиз",
        enterYourPassword: "Сырсөзүңүздү киргизиңиз",
        login: "Кирүү",
        logout: "Чыгуу",
        // Жыйын байланышкан кошумча
        step: "Кадам",
        age: "Мөөнөт",
        ipAddress: "IP дареги",
        departmentId: "Бөлүм ID",
        // Кошумча билдирүүлөр
        pleaseSelectFile: "Файл тандаңыз.",
        canDownloadOnlyOneFile: "Бир гана файлды жүктөп алууга болот.",
        pleaseSelectChildCode: "Кошумча кодду тандаңыз.",
        alreadyNotUsed: "Бул код мурунтан эле колдонулбайт деп белгиленген.",
        errorOccurred: "Ката пайда болду.",
        // SNS видео өчүрүү байланышкан
        deleteVideoConfirmMessage: "Тандалган видеону өчүрөсүзбү?",
        deleteSnsVideoTogether: "SNS ге жүктөлгөн видеолорду да өчүрүү",
        deleteWithSnsSuccess: "SNS видеолору менен бирге өчүрүлдү.",
        deleteSuccess: "Ийгиликтүү өчүрүлдү.",
        updateSuccess: "Ийгиликтүү жаңыланды.",
        cancel: "Жокко чыгаруу",
        // Колдонуучу маалыматы/оңдоо
        userDetail: "Колдонуучу маалыматы",
        userEdit: "Колдонуучуну оңдоо",
        newPassword: "Жаңы сырсөз",
        passwordChangeHint: "Сырсөздү өзгөртүү үчүн төмөндө киргизиңиз. Учурдагы сырсөздү сактоо үчүн бош калтырыңыз.",
        requiredField: "Бул талаа милдеттүү",
        invalidEmail: "Туура эмес электрондук почта форматы",
        passwordMismatch: "Сырсөздөр дал келбейт",
        basicInfo: "Негизги маалымат",
        accountInfo: "Аккаунт маалыматы",
        historyInfo: "Тарыхый маалымат",
        status: "Статус",
        active: "Активдүү",
        inactive: "Активдүү эмес",
        role: "Роль",
        admin: "Администратор",
        editor: "Редактор",
        user: "Колдонуучу",
        timezone: "Убакыт алкагы",
        enterMeetingName: "Жыйындын атын киргизиңиз",
        // Өткөрүү абалы байланышкан
        transferStatus: "Өткөрүү абалы",
        transferHistory: "Өткөрүү тарыхы",
        transferDateTime: "Өткөрүү күнү",
        transferTarget: "Максат",
        failureReason: "Себеби",
        retry: "Кайра",
        noTransferHistory: "Өткөрүү тарыхы жок",
        notTransferred: "Өткөрүлгөн эмес",
        transferSuccess: "Өткөрүү ийгиликтүү",
        transferFailed: "Өткөрүү ишке ашкан жок",
        transferInfo: "Өткөрүү маалыматы",
        ftpTransfer: "FTP өткөрүү",
        // Күндөрдүн кыскартуулары
        mon: "Дш",
        tue: "Шш",
        wed: "Шр",
        thu: "Бш",
        fri: "Жм",
        sat: "Иш",
        sun: "Жк",
        day: "-күн",
        totalStatisticsRatio: "Жалпы статистика катышы",
        videoFolderPath: "Видео папканын жолу *",
        videoFileName: "Видео файлдын аты *",
        fullPath: "Толук жол",
        pleaseEnterVideoPath: "Видео жолун киргизиңиз.",
        pleaseEnterVideoFileName: "Видео файлдын атын киргизиңиз.",
        videoConnectFailed: "Видеону туташтыруу ишке ашкан жок.",
        folderCreate: "Папка түзүү",
        editModeGuide: "Өзгөртүү үчүн төмөндөгү Оңдоо баскычын басыңыз.",
        noLiveScheduleToday: "Бүгүн түз эфир расписаниеси жок.",
        pleaseSelectMeeting: "Жыйын тандаңыз.",
        pleaseSelectPublicStatus: "Ачык статусун тандаңыз.",
        pleaseSelectDate: "Күндү тандаңыз.",
        youtubeAuthSuccess: "YouTube аутентификациясы аяктады.",
        youtubeAuthFailed: "YouTube аутентификациясы ишке ашкан жок.",
        popupBlocked: "Калкып чыгуучу терезе бөгөттөлгөн. Бөгөттөөнү алып салыңыз.",
        fileUploadFailed: "Файл жүктөө ишке ашкан жок.",
        fileUploading: "Файл жүктөлүүдө...",
        uploading: "Жүктөлүүдө...",
        franceParis: "Франция (Париж)",
        germanyBerlin: "Германия (Берлин)",
        russiaMoscow: "Россия (Москва)",
        usNewYork: "АКШ (Нью-Йорк)",
        usLosAngeles: "АКШ (Лос-Анжелес)",
        usChicago: "АКШ (Чикаго)",
        australiaSydney: "Австралия (Сидней)",
        newZealandAuckland: "Жаңы Зеландия (Окленд)",
        // Өчүрүү модалы
        snsUploadedVideoCount: "{count} видео SNS'ке жүктөлгөн.",
        countUnit: "",
    },
    ru: {
        close: "Закрыть",
        register: "Регистрация",
        delete: "Удалить",
        more: "Больше",
        monthlyViews: "Просмотры за месяц",
        video: "Видео",
        comments: "Комментарии",
        like: "Лайк",
        views: "Просмотры",
        times: "Раз",
        items: "Штуки",
        move: "Переместить",
        newFolder: "Новая папка",
        liveBroadcast: "Прямой эфир",
        videoMinutes: "Видео протокол",
        meeting: "Заседание",
        date: "Дата",
        title: "Название",
        agenda: "Повестка дня",
        publicStatus: "Статус публичности",
        details: "Подробности",
        edit: "Редактировать",
        noData: "Нет данных",
        noVideo: "Нет зарегистрированных видео.",
        plenarySession: "Пленарное заседание",
        todayLiveSchedule: "Расписание сегодняшних трансляций",
        noMeeting: "Нет заседаний",
        noCommitteeLive: "Нет зарегистрированных трансляций комитетов.",
        meetingDate: "Дата заседания",
        openingTime: "Время открытия",
        meetingType: "Тип заседания",
        meetingName: "Название заседания",
        naHomepage: "Главная страница Национального собрания",
        videoUpload: "Загрузка видео",
        downloadManualConfirm: "Хотите скачать инструкцию по выдаче?",
        issuanceManual: "Инструкция по выдаче",
        download: "Скачать",
        scheduledLiveMeeting: "Запланированная прямая трансляция",
        dateTime: "Дата и время",
        selectMeeting: "Выберите заседание",
        changeFile: "Изменить файл",
        note: "Примечание",
        videoManagement: "Управление видео",
        meetingCodeManagement: "Управление кодами заседаний",
        meetingManagement: "Управление заседаниями",
        snsConnectionManagement: "Управление API ключами",
        statistics: "Статистика",
        liveBroadcastManagement: "Управление прямыми трансляциями",
        number: "Номер",
        session: "Сессия",
        reenter: "Введите заново",
        upcoming: "Предстоящие",
        inProgress: "В процессе",
        finished: "Завершено",
        committee: "Комитет",
        location: "Место",
        recentVideos: "Недавние видео",
        top3VideosByViews: "Топ 3 видео по просмотрам",
        top3ByPlaylistViews: "Топ 3 по просмотрам по плейлистам",
        size: "Размер",
        time: "Время",
        registrationDate: "Дата регистрации",
        snsRegistrationStatus: "Статус регистрации в SNS",
        backToList: "Вернуться к списку",
        menu: "Меню",
        registered: "Зарегистрировано",
        pleaseEnterAllValues: "Введите все значения.",
        pleaseEnterRequiredValues: "Введите обязательные значения.",
        noFileSelected: "Файл не выбран.",
        all: "Все",
        selectDate: "Выберите дату",
        enterTitle: "Введите название",
        recentMeetings: "Недавние заседания",
        enterInformation: "Введите информацию",
        selectFile: "Выберите файл",
        public: "Публичный",
        partiallyPublic: "Частично публичный",
        private: "Личный",
        deleteKeyConfirm: "Вы хотите удалить ключ?",
        enterMeetingInfo: "Введите информацию о заседании",
        videoRegistration: "Зарегистрировать видео",
        sunday: "Воскресенье",
        monday: "Понедельник",
        tuesday: "Вторник",
        wednesday: "Среда",
        thursday: "Четверг",
        friday: "Пятница",
        saturday: "Суббота",
        fillInBlank: "Заполните пустое поле.",
        pleaseEnter: "Введите.",
        googleLogin: "Вход через Google",
        committeeMeeting: "заседание комитета",
        plenary: "П",
        committeeShort: "К",
        transmission: "Отправка",
        rename: "Переименовать",
        videoRegister: "Регистрация видео",
        meetingRoom: "Зал заседаний",
        type: "Тип",
        none: "Отсутствует",
        folderName: "Имя папки",
        selectFolderToMove: "Пожалуйста, выберите папку для перемещения.",
        renameAction: "Переименовать",
        newName: "Новое имя",
        enterInfoToTransmit: "Пожалуйста, введите информацию для передачи.",
        protocol: "Протокол",
        ipToConnect: "IP для подключения",
        path: "Путь",
        password: "Пароль",
        pleaseEnterPassword: "Пожалуйста, введите ваш пароль.",
        deleteConfirm: "Вы уверены, что хотите удалить это?",
        abnormalAccess: "Ненормальный доступ",
        folderCannotBeTransmitted: "Папки не могут быть отправлены.",
        transmissionComplete: "Передача завершена.",
        transmissionFailed: "Передача не удалась.",
        checkFileExtension: "Пожалуйста, проверьте расширение файла.",
        userManagement: "Управление пользователями",
        // Дополнительные ключи
        select: "Выберите",
        period: "Период",
        filterType: "Тип",
        userCreated: "Пользователь создан",
        userCreationFailed: "Не удалось создать пользователя",
        noUserSelected: "Пользователь не выбран",
        deleteFailed: "Не удалось удалить",
        userName: "Имя пользователя",
        name: "Имя",
        email: "Электронная почта",
        phoneNumber: "Номер телефона",
        pleaseEnterRequiredFields: "Заполните обязательные поля",
        notSelected: "Не выбрано",
        file: "Файл",
        description: "Описание",
        save: "Сохранить",
        videoEdit: "Редактирование видео",
        pleaseCheckInputFields: "Проверьте поля ввода",
        userRegistration: "Регистрация пользователя",
        userId: "ID пользователя",
        confirmPassword: "Подтвердите пароль",
        pleaseSelectGroupCode: "Выберите код группы",
        codeRegistration: "Регистрация кода",
        codeId: "ID кода",
        codeName: "Название кода",
        order: "Порядок",
        memo: "Заметка",
        pleaseSelectStartDate: "Выберите дату начала",
        pleaseSelectEndDate: "Выберите дату окончания",
        sessionRegistration: "Регистрация сессии",
        startDate: "Дата начала",
        endDate: "Дата окончания",
        sessionName: "Название сессии",
        sortOrder: "Порядок сортировки",
        saved: "Сохранено",
        auth: "Аутентификация",
        pleaseSelectSession: "Выберите сессию",
        pleaseSelectScheduledMeetingDate: "Выберите дату заседания",
        pleaseSelectMeetingType: "Выберите тип заседания",
        meetingRegistration: "Регистрация заседания",
        meetingRound: "Тур заседания",
        scheduledMeetingDate: "Запланированная дата заседания",
        // Дополнительные ключи
        connectFile: "Подключить файл",
        viewRelatedVideos: "Просмотреть связанные видео",
        search: "Поиск",
        parentCode: "Родительский код",
        childCode: "Дочерний код",
        id: "ID",
        requestUrl: "URL запроса",
        requestType: "Тип запроса",
        message: "Сообщение",
        accessDate: "Дата доступа",
        daily: "Ежедневно",
        weekly: "Еженедельно",
        monthly: "Ежемесячно",
        count: "Количество",
        sessionId: "ID сессии",
        createdDate: "Дата создания",
        createdBy: "Создатель",
        transferMethod: "Способ передачи",
        searchFolder: "Поиск папки",
        selectTimezone: "Выберите часовой пояс",
        selectStartDate: "Выберите дату начала",
        selectEndDate: "Выберите дату окончания",
        scheduledDate: "Запланированная дата",
        koreaSeoul: "Корея (Сеул)",
        kyrgyzstanBishkek: "Кыргызстан (Бишкек)",
        uzbekistanTashkent: "Узбекистан (Ташкент)",
        kazakhstanAlmaty: "Казахстан (Алматы)",
        turkmenistanAshgabat: "Туркменистан (Ашхабад)",
        tajikistanDushanbe: "Таджикистан (Душанбе)",
        japanTokyo: "Япония (Токио)",
        chinaBeijing: "Китай (Пекин)",
        singapore: "Сингапур",
        indiaDelhi: "Индия (Дели)",
        ukLondon: "Великобритания (Лондон)",
        // Ключи модального окна деталей
        videoTitle: "Название видео",
        fileName: "Имя файла",
        fileSize: "Размер файла",
        playTime: "Время воспроизведения",
        modifiedDate: "Дата изменения",
        modifiedBy: "Изменил",
        meetingPlace: "Место заседания",
        liveId: "ID трансляции",
        meetingTitle: "Название заседания",
        videoFile: "Видеофайл",
        videoPath: "Путь к видео",
        meetingDescription: "Описание заседания",
        useYn: "Статус использования",
        use: "Использовать",
        notUse: "Не использовать",
        videoDetail: "Детали видео",
        snsType: "Тип SNS",
        snsVideoId: "ID видео SNS",
        meetingDetail: "Детали заседания",
        relatedVideos: "Связанные видео",
        videoConnect: "Подключить видео",
        videoConnectSubtitle: "После подключения вы можете управлять им в управлении видео.",
        clickEditToModify: "Нажмите Редактировать для изменения",
        clickSaveToSave: "Нажмите Сохранить для сохранения.",
        requiredMeetingTitle: "Название заседания *",
        requiredVideoFile: "Видеофайл *",
        requiredVideoPath: "Путь к видео *",
        // Связанные с входом
        loginFailed: "Неверный ID или пароль.",
        pleaseEnterIdPassword: "Пожалуйста, введите ID и пароль.",
        // Связанные с меню
        logManagement: "Управление журналами",
        basicCodeManagement: "Управление общими кодами",
        statisticsManagement: "Управление статистикой",
        // Связанные со статистикой
        statisticsLoadFailed: "Не удалось загрузить данные статистики.",
        confirmGenerateStatistics: "Вы хотите сгенерировать статистику?",
        statisticsGeneratedSuccess: "Статистика успешно сгенерирована.",
        statisticsGenerateFailed: "Не удалось сгенерировать статистику.",
        dailyStatisticsTrend: "Тренд дневной статистики (последние 30 дней)",
        weeklyStatisticsTrend: "Тренд недельной статистики (последние 30 недель)",
        monthlyStatisticsTrend: "Тренд месячной статистики (последние 30 месяцев)",
        totalStatisticsTrend: "Тренд общей статистики (на дневной основе, последние 30 дней)",
        statisticsTrend: "Тренд статистики",
        total: "Всего",
        videoUploadLabel: "Загрузка видео",
        snsUpload: "Загрузка в SNS",
        selectMondayHint: "Выберите начало недели (понедельник)",
        generateStatistics: "Генерировать статистику",
        loading: "Загрузка...",
        statisticsTrendRecent30: "Тренд статистики (последние 30 дней)",
        // Связанные с быстрым меню
        quickMenu: "Быстрое меню",
        top: "Наверх",
        // Связанные с системой
        internetBroadcastSystem: "Система интернет-трансляции",
        // Связанные с управлением кодами
        idInUse: "Этот ID уже используется.",
        // Связанные с входом дополнительно
        enterYourId: "Введите ваш ID",
        enterYourPassword: "Введите ваш пароль",
        login: "Вход",
        logout: "Выход",
        // Связанные с заседаниями дополнительно
        step: "Шаг",
        age: "Созыв",
        ipAddress: "IP адрес",
        departmentId: "ID отдела",
        // Дополнительные сообщения
        pleaseSelectFile: "Пожалуйста, выберите файл.",
        canDownloadOnlyOneFile: "Вы можете скачать только один файл.",
        pleaseSelectChildCode: "Пожалуйста, выберите дочерний код.",
        alreadyNotUsed: "Этот код уже помечен как неиспользуемый.",
        errorOccurred: "Произошла ошибка.",
        // Связанные с удалением видео SNS
        deleteVideoConfirmMessage: "Вы уверены, что хотите удалить выбранное видео?",
        deleteSnsVideoTogether: "Также удалить видео, загруженные в SNS",
        deleteWithSnsSuccess: "Удалено вместе с видео SNS.",
        deleteSuccess: "Успешно удалено.",
        updateSuccess: "Успешно обновлено.",
        cancel: "Отмена",
        // Связанные с деталями/редактированием пользователя
        userDetail: "Детали пользователя",
        userEdit: "Редактировать пользователя",
        newPassword: "Новый пароль",
        passwordChangeHint: "Введите ниже, чтобы изменить пароль. Оставьте пустым, чтобы сохранить текущий пароль.",
        requiredField: "Это поле обязательно",
        invalidEmail: "Неверный формат email",
        passwordMismatch: "Пароли не совпадают",
        basicInfo: "Основная информация",
        accountInfo: "Информация об аккаунте",
        historyInfo: "Информация об истории",
        status: "Статус",
        active: "Активный",
        inactive: "Неактивный",
        role: "Роль",
        admin: "Администратор",
        editor: "Редактор",
        user: "Пользователь",
        timezone: "Часовой пояс",
        enterMeetingName: "Введите название заседания",
        // Связанные со статусом передачи
        transferStatus: "Статус передачи",
        transferHistory: "История передачи",
        transferDateTime: "Дата передачи",
        transferTarget: "Цель",
        failureReason: "Причина ошибки",
        retry: "Повторить",
        noTransferHistory: "Нет истории передачи",
        notTransferred: "Не передано",
        transferSuccess: "Передача успешна",
        transferFailed: "Передача не удалась",
        transferInfo: "Информация о передаче",
        ftpTransfer: "FTP передача",
        // Сокращения дней недели
        mon: "Пн",
        tue: "Вт",
        wed: "Ср",
        thu: "Чт",
        fri: "Пт",
        sat: "Сб",
        sun: "Вс",
        day: "",
        totalStatisticsRatio: "Соотношение общей статистики",
        videoFolderPath: "Путь к папке видео *",
        videoFileName: "Имя видеофайла *",
        fullPath: "Полный путь",
        pleaseEnterVideoPath: "Пожалуйста, введите путь к видео.",
        pleaseEnterVideoFileName: "Пожалуйста, введите имя видеофайла.",
        videoConnectFailed: "Не удалось подключить видео.",
        folderCreate: "Создать папку",
        editModeGuide: "Нажмите кнопку Редактировать ниже для изменения.",
        noLiveScheduleToday: "На сегодня нет запланированных трансляций.",
        pleaseSelectMeeting: "Пожалуйста, выберите заседание.",
        pleaseSelectPublicStatus: "Пожалуйста, выберите статус публичности.",
        pleaseSelectDate: "Пожалуйста, выберите дату.",
        youtubeAuthSuccess: "Аутентификация YouTube завершена.",
        youtubeAuthFailed: "Аутентификация YouTube не удалась.",
        popupBlocked: "Всплывающее окно заблокировано. Пожалуйста, разрешите всплывающие окна.",
        fileUploadFailed: "Не удалось загрузить файл.",
        fileUploading: "Загрузка файла...",
        uploading: "Загрузка...",
        franceParis: "Франция (Париж)",
        germanyBerlin: "Германия (Берлин)",
        russiaMoscow: "Россия (Москва)",
        usNewYork: "США (Нью-Йорк)",
        usLosAngeles: "США (Лос-Анджелес)",
        usChicago: "США (Чикаго)",
        australiaSydney: "Австралия (Сидней)",
        newZealandAuckland: "Новая Зеландия (Окленд)",
        // Модал удаления
        snsUploadedVideoCount: "{count} видео загружено в SNS.",
        countUnit: "",
    }
}
